// // import React, { useState } from "react";
// // import ProductZoom from "./ProductZoom";
// // import ProductZoom from "./ProductZoom";
// // import Footer from "./Footer";
// // import SupplierInfoModal from "./SupplierInfoModel";
// // import { Link } from "react-router-dom";

// // const Model = () => {
// //   const [isOpen, setIsOpen] = useState(false);

// //   const handleOpen = () => 
// //     setIsOpen(true)

// //   const handleClose = () => 
// //     setIsOpen(false)
// //   return (
// //     <div>
// //     <div className="container-fluid model-section">
// //       <div className="model-midsize">
// //         Home / <span>Casual Shirts For Men</span>
// //       </div>
// //       <div className="row">
// //         <div className="col-lg-6">
// //           <div className="row model-row">
// //             <ProductZoom/>
// //           </div>
// //         </div>
// //         <div className="col-lg-6">
// //           <div className="rightcontent">
// //             <h3 className="pdp-title">Moda Rapido</h3>
// //             <h3 className="pdp-name">Printed Round Neck T-shirt</h3>
// //             <div className="ratebox">
// //               <p className="num">3.7</p>
// //               <img src="img/star.png" />
// //               <div className="separator">|</div>
// //               <span className="ratingnum">12.2k Ratings</span>
// //             </div>
// //             <div className="hr" />
// //             <div className="disline">
// //               <span className="cost">Rs.421</span>
// //               <s className="totalcost">Rs.640</s>
// //               <span className="discount">(35% OFF)</span>
// //             </div>
// //             <div className="smalltext">Inclusive of all taxes</div>
// //             <div className="size-chart">
// //               <h4 className="size">SELECT SIZE</h4>
// //               <h4 className="chart">SIZE CHART</h4>
// //               <span className="size-button-arrow" />
// //             </div>
// //             <div className="sizes">
// //               <div className="circles">S</div>
// //               <div className="circles">M</div>
// //               <div className="circles">L</div>
// //               <div className="circles">XL</div>
// //               <div className="circles">XXL</div>
// //             </div>
// //             <div className="newdiv">
// //               <Link to="/bag">
// //               <button className="cartbtn" onclick="addtoCart()">
// //                 <img src="img/bag.svg" />
// //                 ADD TO BAG
// //               </button>
// //               </Link>
// //               <button className="wishbtn" onclick="addtoWishList()">
// //                 <img src="img/heart.svg" />
// //                 WISHLIST
// //               </button>
// //             </div>

// //             <div className="delivary-section">
// //               <span>DELIVERY OPTIONS</span>
// //               <img className="van" src="img/van.jpg" />
// //             </div>

// //             <div className="checkbox">
// //               <input type="number" placeholder="Enter a pin code" />
// //               <h4 className="pin">
// //                 Please enter PIN code to check delivery time &amp; Pay on
// //                 Delivery Availability
// //               </h4>
// //             </div>
// //             <div className="bigtextcontainer">
// //               <div>
// //                 <h4 className="bigtext">100% Original Products</h4>
// //               </div>
// //               <div>
// //                 <h4 className="bigtext">Pay on delivery might be available</h4>
// //               </div>
// //               <div>
// //                 <h4 className="bigtext">Easy 30 days returns and exchanges</h4>
// //               </div>
// //               <div>
// //                 <h4 className="bigtext">Try &amp; Buy might be available</h4>
// //               </div>
// //             </div>
// //             <div className="newdiv">
// //               <h4 className="font">
// //                 BEST OFFERS
// //                 <img className="tag" src="img/offer-key.png" />
// //               </h4>
// //             </div>
// //             <div>
// //               <h4 className="font">
// //                 Best Price:<span className="orange"> Rs.84</span>
// //               </h4>
// //             </div>
// //             <ul className="items">
// //               <li>
// //                 Applicable on: Orders above Rs. 2499 (only on first purchase)
// //               </li>
// //               <li>
// //                 Coupon code: <b>MYNTRA400</b>
// //               </li>
// //               <li>
// //                 Coupon Discount: Rs. 400 off (check cart for final savings)
// //               </li>
// //             </ul>
// //             <div className="smalltexter">View Eligible Products</div>
// //             <div>
// //               <h4 className="fot">EMI option available</h4>
// //             </div>
// //             <ul className="items-s">
// //               <li>EMI starting from Rs.20/month</li>
// //             </ul>
// //             <div className="smalltexter">View Plan</div>
// //             <div className="hr" />
// //             <div className="product-newdiv">
// //               <h4 className="font">PRODUCT DETAILS</h4>
// //               <h4 className="bigtext">
// //                 Maroon and black printed T-shirt, has a round neck, long sleeves
// //               </h4>
// //             </div>

// //             <div className="products-newdiv">
// //               <h4 className="font">Size &amp; Fit</h4>
// //             </div>
// //             <div>
// //               <h4 className="bigtext-noGap">
// //                 The model (height 6') is wearing a size M
// //               </h4>
// //             </div>
// //             <div className="products-newdiv">
// //               <h4 className="font">Material &amp; Care</h4>
// //             </div>
// //             <div>
// //               <h4 className="bigtext-noGap">100% cotton</h4>
// //             </div>
// //             <div>
// //               <h4 className="bigtext-noGap">Machine-wash</h4>
// //             </div>
// //             <div className="products-newdiv">
// //               <h4 className="font">Specifications</h4>
// //             </div>
// //             <div className="index-tableContainer">
// //               <div className="index-row">
// //                 <div className="index-rowKey">Fabric</div>
// //                 <div className="index-rowValue">Cotton</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Fit</div>
// //                 <div className="index-rowValue">Regular Fit</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Length</div>
// //                 <div className="index-rowValue">Regular</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Main Trend</div>
// //                 <div className="index-rowValue">Abstract</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Multipack Set</div>
// //                 <div className="index-rowValue">Single</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Neck</div>
// //                 <div className="index-rowValue">Round Neck</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Occasion</div>
// //                 <div className="index-rowValue">Casual</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Pattern</div>
// //                 <div className="index-rowValue">Printed</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Pattern Coverage</div>
// //                 <div className="index-rowValue">Full-Front</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Print or Pattern Type</div>
// //                 <div className="index-rowValue">Abstract</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Sleeve Length</div>
// //                 <div className="index-rowValue">Long Sleeves</div>
// //               </div>
// //               <div className="index-row">
// //                 <div className="index-rowKey">Sleeve Styling</div>
// //                 <div className="index-rowValue">Regular Sleeves</div>
// //               </div>

// //             </div>
// //             <hr/>
// //                 <div className="rating-div">
// //               <h4>
// //                RATINGS
// //                 <i className="fa-regular fa-star" style={{width:"5%"}}></i>
// //               </h4>
// //                 <div className="row">
// //                   <div className="col-lg-3 col-md-3 col-sm-12 rating-div1">
// //                     <h1>4.3 <i className="fa-solid fa-star"></i></h1>
// //                     <p>66 Verified Buyers</p>
// //                   </div>
// //                   <div className="col-lg-1 col-md-1 col-sm-12 rating-div-vl"></div>
// //                     <div className="col-lg-6 col-md-6 col-sm-12 rating-div2">

// //                       5 <i className="fa-solid fa-star"></i> <div className="hr-line"> <div className="progress-fill"></div></div> 40

// //                     </div>
// //                 </div>

// //             </div>
// // <hr/>
// //             <div className="row customer-review">
// //               <h5>Customer Photos</h5>
// //               <div className="customer-review-img">
// //                 <img src="img/acc1.webp"/>
// //                  <img src="img/acc2.webp"/>
// //                   <img src="img/acc3.webp"/>
// //                    <img src="img/acc4.webp"/>
// //                     <img src="img/acc5.webp"/>
// //               </div>
// //             </div>

// //                  <div className="row customer-reviews">
// //               <h5>Customer Reviews</h5>
// //               <div className="col-1 review">
// //                 5 <i className="fa-solid fa-star"></i>
// //               </div>
// //               <div className="col-11 customer-review-img">
// //                 <p>The product perfectly matches the Quality associated with the Raymond brand. The cloth is amazing in both texture and size. Feels light and airy when wore. If you are looking for a mid-priced trouser pant, I would suggest to go with Raymond without any doubts.</p>
// //                    <img src="img/acc4.webp"/>
// //                     <img src="img/acc5.webp"/>
// //               </div>
// //             </div>
// //             <hr/>

// //             <div className="seller-div">
// //               <p>Product Code: <strong>34598</strong></p>
// //               <p>Seller: <span>RAYMOND LIFESTYLE LIMITED</span></p>
// //               <div>
// //               <a onClick={handleOpen}>View Supplier Information</a>

// //               {isOpen && <SupplierInfoModal onClose={handleClose}/>}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="row similar-product-section">
// //         <h3>Similar Product</h3>
// //         <div className="products-card">
// //           <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //            <div>
// //             <img src="img/slider1.webp"/>
// //           </div>
// //         </div>
// //       </div>
// //       </div>
// //       <Footer/>
// //     </div>
// //   );
// // };

// // export default Model;


// import React, { useEffect, useState } from "react";
// import Footer from "./Footer";
// import SupplierInfoModal from "./SupplierInfoModel";
// import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
// import Slider from "react-slick";
// import { getGuestCart, saveGuestCart, getGuestWishlist, saveGuestWishlist, } from "../utils/guestStorage";
// import { toast } from "react-toastify";

// const ProductZoom = ({ images = [] }) => {
//   const [selectedIdx, setSelectedIdx] = useState(0);
//   const [zoomOpen, setZoomOpen] = useState(false);

//   useEffect(() => {
//     setSelectedIdx(0);
//   }, [images]);

//   const openZoom = (idx) => {
//     setSelectedIdx(idx);
//     setZoomOpen(true);
//   };

//   return (
//     <div className="product-images">
//       <div className="main-image text-center">
//         <img
//           src={images[selectedIdx] ?? "img/placeholder.png"}
//           alt={`product-${selectedIdx}`}
//           onClick={() => openZoom(selectedIdx)}
//           style={{ height: "450px", width: "350px" }}
//         />
//       </div>

//       <div
//         className="thumbnail-row"
//         style={{
//           marginTop: "10px",
//           display: "flex",
//           gap: "8px",
//           flexWrap: "wrap",
//         }}
//       >
//         {images.map((img, i) => (
//           <div
//             key={i}
//             className={`thumb ${i === selectedIdx ? "active" : ""}`}
//             onClick={() => setSelectedIdx(i)}
//             style={{
//               width: 60,
//               height: 60,
//               overflow: "hidden",
//               borderRadius: 6,
//               border: i === selectedIdx ? "2px solid #f60" : "1px solid #ddd",
//               cursor: "pointer",
//             }}
//           >
//             <img
//               src={img}
//               alt={`thumb-${i}`}
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//               }}
//             />
//           </div>
//         ))}
//       </div>

//       {zoomOpen && (
//         <div
//           className="zoom-overlay"
//           onClick={() => setZoomOpen(false)}
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.8)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 9999,
//           }}
//         >
//           {/*  Close Button */}
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               setZoomOpen(false);
//             }}
//             style={{
//               position: "absolute",
//               top: "20px",
//               right: "20px",
//               background: "transparent",
//               border: "none",
//               color: "#fff",
//               fontSize: "28px",
//               cursor: "pointer",
//               fontWeight: "bold",
//             }}
//             aria-label="Close"
//           >
//             ×
//           </button>

//           {/* Zoomed Image */}
//           <img
//             src={images[selectedIdx] ?? "img/placeholder.png"}
//             alt="zoomed"
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               maxHeight: "80%",
//               maxWidth: "50%",
//               boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
//             }}
//           />
//         </div>
//       )}

//     </div>
//   );
// };

// // ─────────────────────────────────────────────
// // Helper: render N filled / empty stars
// // ─────────────────────────────────────────────
// const StarRow = ({ count, size = 14 }) => {
//   const stars = [];
//   for (let i = 1; i <= 5; i++) {
//     stars.push(
//       <i
//         key={i}
//         className={i <= count ? "fa-solid fa-star" : "fa-regular fa-star"}
//         style={{ fontSize: size, color: i <= count ? "#f5a623" : "#ccc" }}
//       />
//     );
//   }
//   return <span style={{ display: "inline-flex", gap: 2 }}>{stars}</span>;
// };

// // ─────────────────────────────────────────────
// // ReviewImageLightbox – opens clicked review image full-screen
// // ─────────────────────────────────────────────
// const ReviewImageLightbox = ({ src, onClose }) => (
//   <div
//     onClick={onClose}
//     style={{
//       position: "fixed",
//       inset: 0,
//       background: "rgba(0,0,0,0.85)",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       zIndex: 10000,
//     }}
//   >
//     <button
//       onClick={onClose}
//       style={{
//         position: "absolute",
//         top: 16,
//         right: 20,
//         background: "none",
//         border: "none",
//         color: "#fff",
//         fontSize: 32,
//         cursor: "pointer",
//         fontWeight: "bold",
//       }}
//     >
//       ×
//     </button>
//     <img
//       src={src}
//       alt="review"
//       onClick={(e) => e.stopPropagation()}
//       style={{ maxHeight: "85%", maxWidth: "70%", borderRadius: 8 }}
//     />
//   </div>
// );

// // ─────────────────────────────────────────────
// // Single review card
// // ─────────────────────────────────────────────
// const ReviewCard = ({ review, ensurePublicPath }) => {
//   const [lightboxSrc, setLightboxSrc] = useState(null);

//   // normalise image array
//   const images = Array.isArray(review.image)
//     ? review.image.map((img) => ensurePublicPath(img))
//     : review.image
//     ? [ensurePublicPath(review.image)]
//     : [];

//   // pretty date  e.g. "08 Jan 2026"
//   const dateStr = new Date(review.created_at).toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });

//   return (
//     <div
//       style={{
//         borderBottom: "1px solid #eee",
//         paddingBottom: 16,
//         marginBottom: 16,
//       }}
//     >
//       {/* top row: stars + date */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 6,
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//           <StarRow count={Number(review.rating)} />
//           <span style={{ fontSize: 13, color: "#666", fontWeight: 600 }}>
//             {review.rating}/5
//           </span>
//         </div>
//         <span style={{ fontSize: 12, color: "#999" }}>{dateStr}</span>
//       </div>

//       {/* review text */}
//       <p style={{ margin: "6px 0", fontSize: 14, color: "#333", lineHeight: 1.5 }}>
//         {review.your_review}
//       </p>

//       {/* review images – thumbnail strip */}
//       {images.length > 0 && (
//         <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
//           {images.map((img, idx) => (
//             <img
//               key={idx}
//               src={img}
//               alt={`review-img-${idx}`}
//               onClick={() => setLightboxSrc(img)}
//               style={{
//                 width: 72,
//                 height: 72,
//                 objectFit: "cover",
//                 borderRadius: 6,
//                 border: "1px solid #ddd",
//                 cursor: "pointer",
//                 transition: "transform 0.2s",
//               }}
//               onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
//               onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
//             />
//           ))}
//         </div>
//       )}

//       {/* lightbox portal */}
//       {lightboxSrc && (
//         <ReviewImageLightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />
//       )}
//     </div>
//   );
// };

// const Model = () => {
//   const location = useLocation();
//   const params = useParams();
//   const [isOpen, setIsOpen] = useState(false);
//   const [product, setProduct] = useState(null);
//   const [sizeMap, setSizeMap] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [categoryName, setCategoryName] = useState("");
//   const [colorMap, setColorMap] = useState({});
//   const [similarProducts, setSimilarProducts] = useState([]);
//   const [wishlistIds, setWishlistIds] = useState([]);

//   const [hoveredItemId, setHoveredItemId] = useState(null);

//   const navigate = useNavigate();

//   // NEW – selected size for Add to Cart
//   const [selectedSize, setSelectedSize] = useState("");
//   const [selectedColor, setSelectedColor] = useState("");

//   // ──── REVIEW STATE ────
//   const [reviews, setReviews] = useState([]);        // all fetched reviews
//   const [showAllReviews, setShowAllReviews] = useState(false); // toggle expand

//   const getProductId = () => {
//     if (params.product_id) return params.product_id;

//     const pathParts = location.pathname.split("/");
//     const lastPart = pathParts[pathParts.length - 1];
//     if (lastPart && !isNaN(lastPart)) return lastPart;

//     const urlParams = new URLSearchParams(location.search);
//     return urlParams.get("product_id");
//   };

//   useEffect(() => {
//     const productId = getProductId();
//     if (productId) {
//       fetchProductDetails();
//     } else {
//       setLoading(false);
//       setProduct(null);
//     }
//   }, [location.pathname, location.search]);

//   useEffect(() => {
//     fetchSizeList();
//     fetchColorList();
//   }, []);

//   useEffect(() => {
//     console.log("🟡 CURRENT PRODUCT ID:", String(product?.product_id));
//   }, [product]);

//   useEffect(() => {
//     console.log("❤️ WISHLIST IDS:", wishlistIds);
//   }, [wishlistIds]);


//   const fetchProductDetails = async () => {
//     try {
//       setLoading(true);
//       const productId = getProductId();

//       const formData = new FormData();
//       formData.append("product_id", productId);

//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
//         {
//           method: "POST",
//           body: formData,
//         }
//       );

//       const result = await response.json();

//       if (result?.status) {
//         const data = result.data || {};

//         let images = [];
//         if (Array.isArray(data.multi_image)) {
//           images = data.multi_image.map((p) => ensurePublicPath(p));
//         } else if (typeof data.multi_image === "string") {
//           images = data.multi_image
//             .split(",")
//             .map((p) => ensurePublicPath(p.trim()));
//         }

//         if (images.length === 0) images = ["img/placeholder.png"];

//         setProduct({
//           ...data,
//           multi_image: images,
//         });

//         // Fetch category name after setting product
//         fetchCategoryName(data.category_id);

//         // ⭐ FETCH SIMILAR PRODUCTS HERE
//         fetchSimilarProducts(data.category_id, data.product_id);

//         // ⭐ FETCH REVIEWS
//         fetchReviews(data.product_id);

//       } else {
//         setProduct(null);
//       }
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setProduct(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ──── FETCH REVIEWS ────
//   const fetchReviews = async (productId) => {
//     try {
//       const formData = new FormData();
//       formData.append("product_id", productId);

//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_review",
//         { method: "POST", body: formData }
//       );

//       const result = await response.json();

//       if (result.status && Array.isArray(result.data)) {
//         // only approved reviews, newest first
//         const approved = result.data
//           .filter((r) => r.status === "approve")
//           .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
//         setReviews(approved);
//       } else {
//         setReviews([]);
//       }
//     } catch (err) {
//       console.error("Reviews fetch error:", err);
//       setReviews([]);
//     }
//   };

//   const fetchSizeList = async () => {
//     try {
//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
//       );
//       const result = await response.json();

//       if (result.status) {
//         const map = {};
//         result.row.forEach((item) => {
//           map[item.size_id] = item.size_label;
//         });
//         setSizeMap(map);
//       }
//     } catch (err) {
//       console.error("Size list fetch error:", err);
//     }
//   };

//   const fetchColorList = async () => {
//     try {
//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
//       );
//       const result = await response.json();

//       if (result.status) {
//         const map = {};
//         result.colors.forEach((item) => {
//           map[item.color_id] = {
//             name: item.color_name,
//             preview: item.preview,
//           };
//         });
//         setColorMap(map);
//       }
//     } catch (err) {
//       console.error("Color list fetch error:", err);
//     }
//   };

//   const fetchCategoryName = async (categoryId) => {
//     try {
//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
//       );
//       const result = await response.json();

//       if (result.status) {
//         const category = result.row.find(
//           (cat) => cat.category_id === categoryId
//         );
//         if (category) {
//           setCategoryName(category.category_name);
//         }
//       }
//     } catch (err) {
//       console.error("Category fetch error:", err);
//     }
//   };

//   const fetchSimilarProducts = async (categoryId, currentProductId) => {
//     try {
//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
//       );

//       const result = await response.json();

//       if (result.status && result.data) {
//         const mapped = result.data
//           .filter(
//             (p) =>
//               p.category_id === categoryId &&
//               p.product_id !== currentProductId
//           )
//           .slice(0, 8)
//           .map((p) => ({
//             id: p.product_id,
//             brand: p.company_name || p.assign_vendor,
//             name: p.product_name,
//             price: parseFloat(p.current_price),
//             oldPrice: parseFloat(p.old_price),
//             discount: Math.round(
//               ((p.old_price - p.current_price) / p.old_price) * 100
//             ),
//             images:
//               p.multi_image && p.multi_image.length > 0
//                 ? p.multi_image.map((img) => ensurePublicPath(img))
//                 : ["img/placeholder.png"],
//             rating: parseFloat(p.rating) || 0,
//             viewers: `${Number(p.rating || 0).toFixed(1)}K`,

//             stock: p.status || "In Stock",
//           }));

//         setSimilarProducts(mapped);
//       }
//     } catch (err) {
//       console.error("Similar products error:", err);
//     }
//   };

//   // Dynamic specifications based on category
//   const getSpecifications = () => {
//     if (!product) return [];

//     const catName = categoryName.toLowerCase();

//     if (catName === "electronics") {
//       return [
//         { key: "Brand", value: product.brand || "N/A" },
//         { key: "Model Name", value: product.model_name || "N/A" },
//         { key: "RAM", value: product.ram || "N/A" },
//         { key: "ROM/Storage", value: product.rom || "N/A" },
//         { key: "Processor", value: product.processor || "N/A" },
//         { key: "Camera", value: product.camera || "N/A" },
//         { key: "Battery", value: product.battery || "N/A" },
//         { key: "Operating System", value: product.operating_system || "N/A" },
//         { key: "Available Colors", value: product.available_colors || "N/A" },
//       ];
//     } else if (catName === "fashion") {
//       return [
//         { key: "Fabric", value: product.material || "Cotton" },
//         { key: "Fit", value: product.fit_type || "Regular Fit" },
//         { key: "Brand Name", value: product.fashion_brand_name || "N/A" },
//         { key: "Occasion", value: product.occasion || "Casual" },
//         { key: "Material", value: product.material || "N/A" },
//         { key: "Care Instructions", value: product.care_instructions || "Machine Wash" },
//       ];
//     } else {
//       return [
//         { key: "Brand", value: product.brand || product.fashion_brand_name || "N/A" },
//         { key: "Material", value: product.material || "N/A" },
//         { key: "Description", value: product.description || "N/A" },
//       ];
//     }
//   };

//   const ensurePublicPath = (p) => {
//     if (!p) return "img/placeholder.png";
//     if (p.startsWith("http")) return p;
//     return `https://cyberathon.com/multivendor/${p.replace(/^\/+/, "")}`;
//   };

//   useEffect(() => {
//     const userId = localStorage.getItem("user_id");

//     // 🟡 GUEST USER
//     if (!userId) {
//       const guestWishlist = getGuestWishlist();
//       setWishlistIds(guestWishlist.map((i) => String(i.product_id)));
//       return;
//     }

//     // 🔵 LOGGED-IN USER
//     const fetchWishlist = async () => {
//       try {
//         const formData = new FormData();
//         formData.append("user_id", userId);

//         const res = await fetch(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/wish_list",
//           { method: "POST", body: formData }
//         );

//         const result = await res.json();

//         console.log("🧾 WISHLIST API RESPONSE:", result);

//         if (result.status && Array.isArray(result.wishlist)) {
//           setWishlistIds(
//             result.wishlist.map((i) => String(i.product_id))
//           );
//         }
//       } catch (err) {
//         console.error("Wishlist fetch error", err);
//       }
//     };

//     fetchWishlist();
//   }, [params.product_id]);



//   //  ADD TO CART API FULL INTEGRATION
//   const addToCart = async () => {
//     const userId = localStorage.getItem("user_id");

//     // Size & color validation for fashion
//     if (categoryName.toLowerCase() === "fashion" && !selectedSize) {
//       alert("Please select a size!");
//       return;
//     }

//     if (categoryName.toLowerCase() === "fashion" && !selectedColor) {
//       alert("Please select a color!");
//       return;
//     }

//     // ================= GUEST USER =================
//     if (!userId) {
//       const guestCart = getGuestCart();

//       const existingIndex = guestCart.findIndex(
//         (item) =>
//           item.product_id === product.product_id &&
//           item.size === selectedSize &&
//           item.color === selectedColor
//       );

//       if (existingIndex > -1) {
//         guestCart[existingIndex].cart_qty += 1;
//       } else {
//         guestCart.push({
//           product_id: product.product_id,
//           name: product.product_name,
//           price: product.current_price,
//           image: product.multi_image[0],
//           size: selectedSize,
//           color: selectedColor,
//           cart_qty: 1,
//         });
//       }

//       saveGuestCart(guestCart);
//       alert("Item added to bag (Guest)");
//       navigate("/bag");
//       return;
//     }

//     // ================= LOGGED-IN USER =================
//     try {
//       const formData = new FormData();
//       formData.append("user_id", userId);
//       formData.append("product_id", product.product_id);
//       formData.append("cart_qty", 1);
//       formData.append("size", selectedSize || "");
//       formData.append("color", selectedColor || "");
//       formData.append("current_price", product.current_price);

//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_cart",
//         { method: "POST", body: formData }
//       );

//       const result = await response.json();

//       if (result.status === true || result.success === "1") {
//         // alert("Item added to your cart!");
//         toast.success("Item added to bag!");
//       } else {
//         alert(result.message || "Cannot add item.");
//       }
//     } catch (err) {
//       console.error("Add cart error:", err);
//     }
//   };


//   const addToWishList = async (item) => {
//     if (!item) return;

//     const productId = String(item.id);

//     // 🚫 already in wishlist
//     if (wishlistIds.includes(productId)) return;

//     const userId = localStorage.getItem("user_id");

//     // ================= GUEST USER =================
//     if (!userId) {
//       const guestWishlist = getGuestWishlist();

//       if (guestWishlist.some(p => String(p.product_id) === productId)) return;

//       guestWishlist.push({
//         product_id: productId,
//         name: item.name,
//         price: item.price,
//         image: item.images?.[0],
//       });

//       saveGuestWishlist(guestWishlist);
//       setWishlistIds(prev => [...prev, productId]);
//       return;
//     }

//     // ================= LOGGED-IN USER =================
//     try {
//       const formData = new FormData();
//       formData.append("user_id", userId);
//       formData.append("product_id", productId);

//       const response = await fetch(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_wish",
//         { method: "POST", body: formData }
//       );

//       const result = await response.json();

//       if (result.status === true) {
//         setWishlistIds(prev => [...prev, productId]);
//       }
//     } catch (err) {
//       console.error("Wishlist error:", err);
//     }
//   };



//   const handleOpen = () => setIsOpen(true);
//   const handleClose = () => setIsOpen(false);

//   const parseSizes = (sizeString) => {
//     if (!sizeString) return [];
//     const sizeIds = sizeString
//       .split(",")
//       .map((s) => s.trim())
//       .filter(Boolean);
//     return sizeIds;
//   };

//   const parseColors = (colorString) => {
//     if (!colorString) return [];
//     const colorIds = colorString
//       .split(",")
//       .map((s) => s.trim())
//       .filter(Boolean);
//     return colorIds;
//   };

//   // ──── DERIVED: rating breakdown from reviews ────
//   const ratingBreakdown = (() => {
//     const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
//     reviews.forEach((r) => {
//       const val = Number(r.rating);
//       if (val >= 1 && val <= 5) counts[val]++;
//     });
//     return counts;
//   })();

//   const averageRating = (() => {
//     if (reviews.length === 0) return Number(product?.rating || 0);
//     const sum = reviews.reduce((acc, r) => acc + Number(r.rating), 0);
//     return (sum / reviews.length).toFixed(1);
//   })();

//   // ──── which reviews to actually render ────
//   const visibleReviews = showAllReviews ? reviews : reviews.slice(0, 1);

//   if (loading) {
//     return (
//       <div className="text-center py-5">
//         <h3>Loading product...</h3>
//       </div>
//     );
//   }

//   if (!product) {
//     return (
//       <div className="text-center py-5">
//         <h3>Product not found.</h3>
//       </div>
//     );
//   }

//   const sizeGroups = parseSizes(product.available_size);
//   const colorGroups = parseColors(product.available_color);

//   const sliderSettings = {
//     dots: true,
//     arrows: false,
//     infinite: true,
//     speed: 500,
//     autoplay: true,
//     autoplaySpeed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//   };

//   const currentProductId = String(product.product_id);
//   const isWishlisted = wishlistIds.includes(currentProductId);

//   console.log("🔍 CHECK:", {
//     currentProductId,
//     wishlistIds,
//     isWishlisted,
//   });



//   return (
//     <div>
//       <div className="container-fluid model-section">
//         <div className="model-midsize">
//           Home / <span>Casual Shirts For Men</span>
//         </div>

//         <div className="row" style={{ position: "relative" }}>

//           <div
//             className="col-lg-6"
//             style={{ position: "sticky", top: "80px", alignSelf: "flex-start", height: "fit-content" }}
//             onWheel={(e) => {
//               e.preventDefault();
//               const rightSide = document.getElementById('right-side-scrollable');
//               if (rightSide) {
//                 rightSide.scrollTop += e.deltaY;
//               }
//             }}
//           >
//             <div className="row model-row">
//               <ProductZoom images={product.multi_image} />
//             </div>
//           </div>

//           {/* RIGHT SIDE DETAILS */}
//           <div
//             id="right-side-scrollable"
//             className="col-lg-6"
//             style={{ overflowY: "auto", maxHeight: "calc(100vh - 100px)" }}
//           >
//             <div className="rightcontent">
//               <div className="row align-items-start">
//                 <div className="col-md-10">
//                   <h3 className="pdp-title">{product.product_name}</h3>
//                   <h3 className="pdp-name">{product.company_name}</h3>
//                 </div>

//                 <div className="col-md-2 text-end">
//                   <button
//                     className="wishbtn"
//                     onClick={() =>
//                       addToWishList({
//                         id: currentProductId,
//                         name: product.product_name,
//                         price: product.current_price,
//                         images: product.multi_image,
//                       })
//                     }
//                   >
//                     <i
//                       className={
//                         isWishlisted
//                           ? "fa-solid fa-heart text-danger"
//                           : "fa-regular fa-heart"
//                       }
//                       style={{ fontSize: "22px" }}
//                     ></i>
//                   </button>

//                 </div>
//               </div>

//               <div className="ratebox">
//                 <p className="num">{product.rating}</p>
//                 <img src="/img/rating.png" alt="star" />
//               </div>

//               <div className="hr" />

//               <div className="disline">
//                 <span className="cost">{product.current_price}</span>
//                 <s className="totalcost">{product.old_price}</s>
//                 <span className="discount">{product.discount}% OFF</span>
//               </div>

//               <div className="smalltext">Inclusive of all taxes</div>

//               {/* SIZE SECTION - Only show for Fashion category */}
//               {categoryName.toLowerCase() === "fashion" && (
//                 <>
//                   <div className="size-chart">
//                     <h4 className="size">SELECT SIZE</h4>
//                     <h4 className="chart">SIZE CHART</h4>
//                     <span className="size-button-arrow" />
//                   </div>

//                   <div className="sizes">
//                     {sizeGroups.length === 0 && (
//                       <div className="circles">One Size</div>
//                     )}

//                     {sizeGroups.map((sizeId, index) => {
//                       const label = sizeMap[sizeId] || sizeId;

//                       return (
//                         <div
//                           className="circles"
//                           key={index}
//                           onClick={() => {
//                             console.log("Selected Size ID:", sizeId, "Label:", label);
//                             setSelectedSize(sizeId);
//                           }}
//                           style={{
//                             border:
//                               selectedSize === sizeId
//                                 ? "2px solid #ff3e6c"
//                                 : "1px solid #ddd",
//                             cursor: "pointer",
//                           }}
//                         >
//                           {label}
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </>
//               )}

//               {/* COLOR SECTION - Show for Fashion and Electronics */}
//               {(categoryName.toLowerCase() === "fashion" ||
//                 categoryName.toLowerCase() === "electronics") && (
//                   <>
//                     <div className="size-chart" style={{ marginTop: 16 }}>
//                       <h4 className="size">SELECT COLOR</h4>
//                     </div>

//                     <div className="sizes" style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "45px" }}>
//                       {colorGroups.length === 0 && (
//                         <div className="circles">Default Color</div>
//                       )}

//                       {colorGroups.map((colorId, index) => {
//                         const colorData = colorMap[colorId];
//                         const colorName = colorData?.name || colorId;
//                         const colorPreview = colorData?.preview || "#cccccc";


//                         return (
//                           <div
//                             key={index}
//                             onClick={() => {
//                               console.log("Selected Color ID:", colorId, "Name:", colorName);
//                               setSelectedColor(colorId);
//                             }}
//                             style={{
//                               display: "flex",
//                               flexDirection: "column",
//                               alignItems: "center",
//                               cursor: "pointer",
//                               padding: "8px",
//                               border:
//                                 selectedColor === colorId
//                                   ? "2px solid #ff3e6c"
//                                   : "1px solid #ddd",
//                               borderRadius: "8px",
//                               minWidth: "70px",
//                             }}
//                           >
//                             <div
//                               style={{
//                                 width: "40px",
//                                 height: "40px",
//                                 borderRadius: "50%",
//                                 backgroundColor: colorPreview,
//                                 border: "2px solid #ddd",
//                                 marginBottom: "4px",
//                               }}
//                             />
//                             <span style={{ fontSize: "12px", textAlign: "center" }}>
//                               {colorName}
//                             </span>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </>
//                 )}

//               {/* BUTTONS */}
//               <div className="newdiv" style={{ marginTop: 12 }}>
//                 <Link to="/bag">
//                   <button className="cartbtn" onClick={addToCart}>
//                     <img src="/img/thunder.png" alt="bag" style={{ width: "25px" }} />
//                     Buy Now
//                   </button>
//                 </Link>

//                 <button className="cartbtn" onClick={addToCart}>
//                   <img src="/img/bag.svg" alt="bag" />
//                   Add to cart
//                 </button>
//               </div>

//               {/* Rest of your design untouched */}
//               {/* DELIVERY, DETAILS, REVIEWS, SUPPLIER INFO, etc. */}
//               {/* ------------------------- */}

//               <div className="delivary-section" style={{ marginTop: 12 }}>
//                 <span>DELIVERY OPTIONS</span>
//                 <img className="van" src="/img/van.jpg" alt="van" />
//               </div>

//               <div className="checkbox" style={{ marginTop: 8 }}>
//                 <input type="number" placeholder="Enter a pin code" />
//                 <h4 className="pin">
//                   Please enter PIN code to check delivery time & Pay on Delivery
//                   Availability
//                 </h4>
//               </div>

//               <div className="bigtextcontainer">
//                 <div>
//                   <h4 className="bigtext">{product.description}</h4>
//                 </div>
//               </div>

//               <div className="newdiv" style={{ marginTop: 12 }}>
//                 <h4 className="font">
//                   BEST OFFERS
//                   <img className="tag" src="/img/offer-key.png" alt="offer" />
//                 </h4>
//               </div>

//               <div>
//                 <h4 className="font">
//                   Best Price:
//                   <span className="orange">{product.current_price}</span>
//                 </h4>
//               </div>

//               <div className="smalltexter">View Eligible Products</div>

//               <div className="hr" />

//               <div className="product-newdiv">
//                 <h4 className="font">PRODUCT DETAILS</h4>
//                 <h4 className="bigtext">{product.product_details}</h4>
//               </div>

//               <div className="products-newdiv">
//                 <h4 className="font">Material &amp; Care</h4>
//               </div>
//               <div>
//                 <h4 className="bigtext-noGap">{product.material || "N/A"}</h4>
//               </div>
//               <div>
//                 <h4 className="bigtext-noGap">Machine-wash</h4>
//               </div>

//               <div className="products-newdiv">
//                 <h4 className="font">Specifications</h4>
//               </div>

//               {/* DYNAMIC SPECIFICATIONS */}
//               <div className="index-tableContainer">
//                 {getSpecifications().map((spec, index) => (
//                   <div className="index-row" key={index}>
//                     <div className="index-rowKey">{spec.key}</div>
//                     <div className="index-rowValue">{spec.value}</div>
//                   </div>
//                 ))}
//               </div>

//               {/* <hr /> */}

//               {/* ══════════════════════════════════════════════
//                   RATINGS  –  now driven by live review data
//                   ══════════════════════════════════════════════ */}
//               {/* <div className="rating-div">
//                 <h4>
//                   RATINGS{" "}
//                   <i className="fa-regular fa-star" style={{ width: "5%" }}></i>
//                 </h4>
//                 <div className="row">
//                   <div className="col-lg-3 col-md-3 col-sm-12 rating-div1">
//                     <h1>
//                       {averageRating} <i className="fa-solid fa-star"></i>
//                     </h1>
//                     <p style={{ fontSize: 13, color: "#666" }}>
//                       {reviews.length} {reviews.length === 1 ? "Review" : "Reviews"}
//                     </p>
//                   </div>

//                   <div className="col-lg-1 col-md-1 col-sm-12 rating-div-vl"></div>

//                   <div className="col-lg-6 col-md-6 col-sm-12 rating-div2">
//                     {[5, 4, 3, 2, 1].map((star) => {
//                       const count = ratingBreakdown[star];
//                       const pct = reviews.length > 0 ? (count / reviews.length) * 100 : 0;
//                       return (
//                         <div
//                           key={star}
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 8,
//                             marginBottom: 5,
//                           }}
//                         >
                  
//                           <span style={{ fontSize: 13, minWidth: 20, textAlign: "right" }}>
//                             {star}
//                           </span>
//                           <i className="fa-solid fa-star" style={{ fontSize: 12, color: "#f5a623" }} />

                        
//                           <div
//                             style={{
//                               flex: 1,
//                               height: 8,
//                               background: "#eee",
//                               borderRadius: 4,
//                               overflow: "hidden",
//                             }}
//                           >
//                             <div
//                               className="progress-fill"
//                               style={{
//                                 width: `${pct}%`,
//                                 height: "100%",
//                                 background: "#f5a623",
//                                 borderRadius: 4,
//                                 transition: "width 0.4s ease",
//                               }}
//                             />
//                           </div>

                
//                           <span style={{ fontSize: 13, minWidth: 22 }}>{count}</span>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               </div> */}

//               <hr />

//               {/* ══════════════════════════════════════════════
//                   CUSTOMER PHOTOS  –  pulled from review images
//                   ══════════════════════════════════════════════ */}
//               {(() => {
//                 // collect all review images into a flat list (max 5 shown)
//                 const allReviewImages = reviews.flatMap((r) =>
//                   Array.isArray(r.image)
//                     ? r.image.map((img) => ensurePublicPath(img))
//                     : r.image
//                     ? [ensurePublicPath(r.image)]
//                     : []
//                 );
//                 return allReviewImages.length > 0 ? (
//                   <div className="row customer-review">
//                     <h5>Customer Photos</h5>
//                     <div className="customer-review-img">
//                       {allReviewImages.slice(0, 5).map((img, idx) => (
//                         <img key={idx} src={img} alt={`customer-photo-${idx}`} />
//                       ))}
//                     </div>
//                   </div>
//                 ) : null;
//               })()}

//               {/* ══════════════════════════════════════════════
//                   CUSTOMER REVIEWS  –  1 shown, expand on click
//                   ══════════════════════════════════════════════ */}
//               <div className="row customer-reviews" style={{ marginTop: 8 }}>
//                 <h5>Customer Reviews</h5>

//                 {/* no reviews at all */}
//                 {reviews.length === 0 && (
//                   <p style={{ fontSize: 14, color: "#999", margin: "8px 0" }}>
//                     No reviews yet. Be the first to review this product!
//                   </p>
//                 )}

//                 {/* visible review cards */}
//                 {visibleReviews.map((review) => (
//                   <ReviewCard
//                     key={review.id}
//                     review={review}
//                     ensurePublicPath={ensurePublicPath}
//                   />
//                 ))}

//                 {/* ── Show All / Show Less button ── */}
//                 {reviews.length > 1 && (
//                   <button
//                     type="button"
//                     onClick={() => setShowAllReviews((prev) => !prev)}
//                     style={{
//                       display: "inline-block",
//                       marginTop: 10,
//                       padding: "8px 20px",
//                       background: "transparent",
//                       border: "1.5px solid #ff3e6c",
//                       color: "#ff3e6c",
//                       borderRadius: 20,
//                       fontSize: 14,
//                       fontWeight: 600,
//                       cursor: "pointer",
//                       transition: "background 0.2s, color 0.2s",
//                     }}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.background = "#ff3e6c";
//                       e.currentTarget.style.color = "#fff";
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.background = "transparent";
//                       e.currentTarget.style.color = "#ff3e6c";
//                     }}
//                   >
//                     {showAllReviews
//                       ? "Show Less"
//                       : `Show All Reviews (${reviews.length})`}
//                   </button>
//                 )}
//               </div>

//               <hr />

//               <div className="seller-div">
//                 <p>
//                   Product Code: <strong>{product.product_id}</strong>
//                 </p>
//                 <p>
//                   Seller: <span>{product.assign_vendor}</span>
//                 </p>
//                 {product.show_seller === "yes" && (
//   <div>
//     <a onClick={handleOpen} style={{ cursor: "pointer" }}>
//       View Supplier Information
//     </a>

//     {isOpen && (
//       <SupplierInfoModal
//         onClose={handleClose}
//         sellerId={product.seller_id}
//         productId={product.product_id}
//       />
//     )}
//   </div>
// )}

//               </div>

//             </div>
//           </div>
//         </div>

//         {/* SIMILAR PRODUCTS */}
//         {/* SIMILAR PRODUCTS */}
//         <div className="row similar-product-section">
//           <h3>Similar Products</h3>

//           <div className="col-lg-12 col-md-9 col-sm-12 products-right">
//             <div className="row">
//               {similarProducts.map((item) => (
//                 <div
//                   key={item.id}
//                   className="col-lg-3 col-md-4 col-sm-6 product-list"
//                   onMouseEnter={() => setHoveredItemId(item.id)}
//                   onMouseLeave={() => setHoveredItemId(null)}
//                   style={{ position: "relative" }}
//                 >
//                   <Link className="product" to={`/model/${item.id}`}>
//                     <div className="image-container">
//                       {hoveredItemId === item.id && item.images.length > 1 ? (
//                         <Slider {...sliderSettings}>
//                           {item.images.map((img, idx) => (
//                             <img key={idx} src={img} alt={`slide-${idx}`} />
//                           ))}
//                         </Slider>
//                       ) : (
//                         <div className="product-img">
//                           <img src={item.images[0]} alt={item.name} />
//                           <div className="product-rating">
//                             <p>
//                               {item.rating} <i className="fa-solid fa-star"></i> |{" "}
//                               {item.viewers}
//                             </p>
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     {hoveredItemId === item.id && (
//                       <div className="wishlist">
//                         <button
//                           type="button"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             e.stopPropagation();

//                             // prevent duplicate add
//                             if (!wishlistIds.includes(item.id)) {
//                               addToWishList(item);
//                             }
//                           }}
//                         >
//                           <i
//                             className={
//                               wishlistIds.includes(String(item.id))
//                                 ? "fa-solid fa-heart text-danger"
//                                 : "fa-regular fa-heart"
//                             }
//                           ></i>
//                           Wishlist
//                         </button>
//                       </div>
//                     )}



//                     <div className="product-detail">
//                       <div className="stock-availability">{item.stock}</div>
//                       <div className="brand">{item.brand}</div>
//                       <div className="name">{item.name}</div>
//                       <div className="price">
//                         ₹{item.price}
//                         <span className="line-through"> ₹{item.oldPrice}</span>
//                         <span className="discount"> ({item.discount}% OFF)</span>
//                       </div>
//                     </div>
//                   </Link>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>


//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default Model;










import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import SupplierInfoModal from "./SupplierInfoModel";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import Slider from "react-slick";
import ReactImageMagnify from "react-image-magnify";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { getGuestCart, saveGuestCart, getGuestWishlist, saveGuestWishlist, } from "../utils/guestStorage";
import { toast } from "react-toastify";

const ProductZoom = ({ images = [], overlay }) => {
  const safeImages = images.length > 0 ? images : ["img/placeholder.png"];

  const [mainImage, setMainImage] = useState(safeImages[0]);
  const [isOpen, setIsOpen] = useState(false);

  // keep mainImage in sync whenever the product (and its images) changes
  useEffect(() => {
    setMainImage(safeImages[0]);
  }, [images]);

  return (
    <div className="product-images">
      {/* Main Image with Magnify */}
      <div
        className="main-image text-center image-wrapper"
        onClick={() => setIsOpen(true)}
        style={{ cursor: 'zoom-in', zIndex: 1, position: "relative" }}
      >
        <ReactImageMagnify
          {...{
            smallImage: {
    src: mainImage,
    width: 330,
    height: 420,
    isFluidWidth: false,
},
            largeImage: {
              src: mainImage,
              width: 2000,
              height: 2500,
            },
            enlargedImageContainerDimensions: {
              width: '95%',
              height: '60%',
            },
            shouldUsePositiveSpaceLens: true,
            enlargedImagePosition: 'beside',
          }}
        />

        {/* ❤️ Wishlist + ⭐ Rating overlay (kept exactly as in original main image) */}
        {overlay}
      </div>

      {/* Thumbnails row - below the main image, like before */}
      <div
        className="thumbnail-row"
        style={{ marginTop: "10px", display: "flex", gap: "8px", flexWrap: "wrap" }}
      >
        {safeImages.map((img, i) => (
          <div
            key={i}
            className={`thumb ${img === mainImage ? "active" : ""}`}
            onClick={() => setMainImage(img)}
            style={{
              width: 60,
              height: 60,
              overflow: "hidden",
              borderRadius: 6,
              border: img === mainImage ? "2px solid #f60" : "1px solid #ddd",
              cursor: "pointer",
            }}
          >
            <img
              src={img}
              alt={`thumb-${i}`}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {isOpen && (
        <Lightbox
          mainSrc={mainImage}
          nextSrc={safeImages[(safeImages.indexOf(mainImage) + 1) % safeImages.length]}
          prevSrc={safeImages[(safeImages.indexOf(mainImage) + safeImages.length - 1) % safeImages.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setMainImage(safeImages[(safeImages.indexOf(mainImage) + safeImages.length - 1) % safeImages.length])
          }
          onMoveNextRequest={() =>
            setMainImage(safeImages[(safeImages.indexOf(mainImage) + 1) % safeImages.length])
          }
        />
      )}
    </div>
  );
};

// ─────────────────────────────────────────────
// Helper: render N filled / empty stars
// ─────────────────────────────────────────────
const StarRow = ({ count, size = 14 }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <i
        key={i}
        className={i <= count ? "fa-solid fa-star" : "fa-regular fa-star"}
        style={{ fontSize: size, color: i <= count ? "#f5a623" : "#ccc" }}
      />
    );
  }
  return <span style={{ display: "inline-flex", gap: 2 }}>{stars}</span>;
};

// ─────────────────────────────────────────────
// ReviewImageLightbox – opens clicked review image full-screen
// ─────────────────────────────────────────────
const ReviewImageLightbox = ({ src, onClose }) => (
  <div
    onClick={onClose}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.85)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10000,
    }}
  >
    <button
      onClick={onClose}
      style={{
        position: "absolute",
        top: 16,
        right: 20,
        background: "none",
        border: "none",
        color: "#fff",
        fontSize: 32,
        cursor: "pointer",
        fontWeight: "bold",
      }}
    >
      ×
    </button>
    <img
      src={src}
      alt="review"
      onClick={(e) => e.stopPropagation()}
      style={{ maxHeight: "85%", maxWidth: "70%", borderRadius: 8 }}
    />
  </div>
);

// ─────────────────────────────────────────────
// Single review card
// ─────────────────────────────────────────────
const ReviewCard = ({ review, ensurePublicPath }) => {
  const [lightboxSrc, setLightboxSrc] = useState(null);

  // normalise image array
  const images = Array.isArray(review.image)
    ? review.image.map((img) => ensurePublicPath(img))
    : review.image
      ? [ensurePublicPath(review.image)]
      : [];

  // pretty date  e.g. "08 Jan 2026"
  const dateStr = new Date(review.created_at).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <div
      style={{
        borderBottom: "1px solid #eee",
        paddingBottom: 16,
        marginBottom: 16,
      }}
    >
      {/* top row: stars + date */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 6,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <StarRow count={Number(review.rating)} />
          <span style={{ fontSize: 13, color: "#666", fontWeight: 600 }}>
            {review.rating}/5
          </span>
        </div>
        <span style={{ fontSize: 12, color: "#999" }}>{dateStr}</span>
      </div>

      {/* review text */}
      <p style={{ margin: "6px 0", fontSize: 14, color: "#333", lineHeight: 1.5 }}>
        {review.your_review}
      </p>

      {/* review images – thumbnail strip */}
      {images.length > 0 && (
        <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
          {images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`review-img-${idx}`}
              onClick={() => setLightboxSrc(img)}
              style={{
                width: 72,
                height: 72,
                objectFit: "cover",
                borderRadius: 6,
                border: "1px solid #ddd",
                cursor: "pointer",
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
          ))}
        </div>
      )}

      {/* lightbox portal */}
      {lightboxSrc && (
        <ReviewImageLightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />
      )}
    </div>
  );
};

const Model = () => {
  const location = useLocation();
  const params = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [product, setProduct] = useState(null);
  const [sizeMap, setSizeMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [categoryName, setCategoryName] = useState("");
  const [colorMap, setColorMap] = useState({});
  const [similarProducts, setSimilarProducts] = useState([]);
  const [wishlistIds, setWishlistIds] = useState([]);

  const [hoveredItemId, setHoveredItemId] = useState(null);

  const navigate = useNavigate();

  // NEW – selected size for Add to Cart
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");

  // ──── REVIEW STATE ────
  const [reviews, setReviews] = useState([]);        // all fetched reviews
  const [showAllReviews, setShowAllReviews] = useState(false); // toggle expand

  const getProductId = () => {
    if (params.product_id) return params.product_id;

    const pathParts = location.pathname.split("/");
    const lastPart = pathParts[pathParts.length - 1];
    if (lastPart && !isNaN(lastPart)) return lastPart;

    const urlParams = new URLSearchParams(location.search);
    return urlParams.get("product_id");
  };

  useEffect(() => {
    const productId = getProductId();
    if (productId) {
      fetchProductDetails();
    } else {
      setLoading(false);
      setProduct(null);
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    fetchSizeList();
    fetchColorList();
  }, []);

  useEffect(() => {
    console.log("🟡 CURRENT PRODUCT ID:", String(product?.product_id));
  }, [product]);

  useEffect(() => {
    console.log("❤️ WISHLIST IDS:", wishlistIds);
  }, [wishlistIds]);


  const fetchProductDetails = async () => {
    try {
      setLoading(true);
      const productId = getProductId();

      const formData = new FormData();
      formData.append("product_id", productId);

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result?.status) {
        const data = result.data || {};

        let images = [];
        if (Array.isArray(data.multi_image)) {
          images = data.multi_image.map((p) => ensurePublicPath(p));
        } else if (typeof data.multi_image === "string") {
          images = data.multi_image
            .split(",")
            .map((p) => ensurePublicPath(p.trim()));
        }

        if (images.length === 0) images = ["img/placeholder.png"];

        setProduct({
          ...data,
          multi_image: images,
        });

        // Fetch category name after setting product
        fetchCategoryName(data.category_id);

        // ⭐ FETCH SIMILAR PRODUCTS HERE
        fetchSimilarProducts(data.category_id, data.product_id);

        // ⭐ FETCH REVIEWS
        fetchReviews(data.product_id);

      } else {
        setProduct(null);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setProduct(null);
    } finally {
      setLoading(false);
    }
  };

  // ──── FETCH REVIEWS ────
  const fetchReviews = async (productId) => {
    try {
      const formData = new FormData();
      formData.append("product_id", productId);

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_review",
        { method: "POST", body: formData }
      );

      const result = await response.json();

      if (result.status && Array.isArray(result.data)) {
        // only approved reviews, newest first
        const approved = result.data
          .filter((r) => r.status === "approve")
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setReviews(approved);
      } else {
        setReviews([]);
      }
    } catch (err) {
      console.error("Reviews fetch error:", err);
      setReviews([]);
    }
  };

  const fetchSizeList = async () => {
    try {
      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
      );
      const result = await response.json();

      if (result.status) {
        const map = {};
        result.row.forEach((item) => {
          map[item.size_id] = item.size_label;
        });
        setSizeMap(map);
      }
    } catch (err) {
      console.error("Size list fetch error:", err);
    }
  };

  const fetchColorList = async () => {
    try {
      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
      );
      const result = await response.json();

      if (result.status) {
        const map = {};
        result.colors.forEach((item) => {
          map[item.color_id] = {
            name: item.color_name,
            preview: item.preview,
          };
        });
        setColorMap(map);
      }
    } catch (err) {
      console.error("Color list fetch error:", err);
    }
  };

  const fetchCategoryName = async (categoryId) => {
    try {
      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
      );
      const result = await response.json();

      if (result.status) {
        const category = result.row.find(
          (cat) => cat.category_id === categoryId
        );
        if (category) {
          setCategoryName(category.category_name);
        }
      }
    } catch (err) {
      console.error("Category fetch error:", err);
    }
  };

  const fetchSimilarProducts = async (categoryId, currentProductId) => {
    try {
      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
      );

      const result = await response.json();

      if (result.status && result.data) {
        const mapped = result.data
          .filter(
            (p) =>
              p.category_id === categoryId &&
              p.product_id !== currentProductId
          )
          .slice(0, 8)
          .map((p) => ({
            id: p.product_id,
            brand: p.company_name || p.assign_vendor,
            name: p.product_name,
            price: parseFloat(p.current_price),
            oldPrice: parseFloat(p.old_price),
            discount: Math.round(
              ((p.old_price - p.current_price) / p.old_price) * 100
            ),
            images:
              p.multi_image && p.multi_image.length > 0
                ? p.multi_image.map((img) => ensurePublicPath(img))
                : ["img/placeholder.png"],
            rating: parseFloat(p.rating) || 0,
            viewers: `${Number(p.rating || 0).toFixed(1)}K`,

            stock: p.status || "In Stock",
          }));

        setSimilarProducts(mapped);
      }
    } catch (err) {
      console.error("Similar products error:", err);
    }
  };

  // Dynamic specifications based on category
  const getSpecifications = () => {
    if (!product) return [];

    const catName = categoryName.toLowerCase();

    if (catName === "electronics") {
      return [
        { key: "Brand", value: product.brand || "N/A" },
        { key: "Model Name", value: product.model_name || "N/A" },
        { key: "RAM", value: product.ram || "N/A" },
        { key: "ROM/Storage", value: product.rom || "N/A" },
        { key: "Processor", value: product.processor || "N/A" },
        { key: "Camera", value: product.camera || "N/A" },
        { key: "Battery", value: product.battery || "N/A" },
        { key: "Operating System", value: product.operating_system || "N/A" },
        { key: "Available Colors", value: product.available_colors || "N/A" },
      ];
    } else if (catName === "fashion") {
      return [
        { key: "Fabric", value: product.material || "Cotton" },
        { key: "Fit", value: product.fit_type || "Regular Fit" },
        { key: "Brand Name", value: product.fashion_brand_name || "N/A" },
        { key: "Occasion", value: product.occasion || "Casual" },
        { key: "Material", value: product.material || "N/A" },
        { key: "Care Instructions", value: product.care_instructions || "Machine Wash" },
      ];
    } else {
      return [
        { key: "Brand", value: product.brand || product.fashion_brand_name || "N/A" },
        { key: "Material", value: product.material || "N/A" },
        { key: "Description", value: product.description || "N/A" },
      ];
    }
  };

  const ensurePublicPath = (p) => {
    if (!p) return "img/placeholder.png";
    if (p.startsWith("http")) return p;
    return `https://cyberathon.com/multivendor/${p.replace(/^\/+/, "")}`;
  };

  useEffect(() => {
    const userId = localStorage.getItem("user_id");

    // 🟡 GUEST USER
    if (!userId) {
      const guestWishlist = getGuestWishlist();
      setWishlistIds(guestWishlist.map((i) => String(i.product_id)));
      return;
    }

    // 🔵 LOGGED-IN USER
    const fetchWishlist = async () => {
      try {
        const formData = new FormData();
        formData.append("user_id", userId);

        const res = await fetch(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/wish_list",
          { method: "POST", body: formData }
        );

        const result = await res.json();

        console.log("🧾 WISHLIST API RESPONSE:", result);

        if (result.status && Array.isArray(result.wishlist)) {
          setWishlistIds(
            result.wishlist.map((i) => String(i.product_id))
          );
        }
      } catch (err) {
        console.error("Wishlist fetch error", err);
      }
    };

    fetchWishlist();
  }, [params.product_id]);



  // ⭐ ADD TO CART API FULL INTEGRATION
  const addToCart = async () => {
    const userId = localStorage.getItem("user_id");

    // Size & color validation for fashion
    if (categoryName.toLowerCase() === "fashion" && !selectedSize) {
      alert("Please select a size!");
      return;
    }

    if (categoryName.toLowerCase() === "fashion" && !selectedColor) {
      alert("Please select a color!");
      return;
    }

    // ================= GUEST USER =================
    if (!userId) {
      const guestCart = getGuestCart();

      const existingIndex = guestCart.findIndex(
        (item) =>
          item.product_id === product.product_id &&
          item.size === selectedSize &&
          item.color === selectedColor
      );

      if (existingIndex > -1) {
        guestCart[existingIndex].cart_qty += 1;
      } else {
        guestCart.push({
          product_id: product.product_id,
          name: product.product_name,
          price: product.current_price,
          image: product.multi_image[0],
          size: selectedSize,
          color: selectedColor,
          cart_qty: 1,
        });
      }

      saveGuestCart(guestCart);
      alert("Item added to bag (Guest)");
      navigate("/bag");
      return;
    }

    // ================= LOGGED-IN USER =================
    try {
      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("product_id", product.product_id);
      formData.append("cart_qty", 1);
      formData.append("size", selectedSize || "");
      formData.append("color", selectedColor || "");
      formData.append("current_price", product.current_price);

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_cart",
        { method: "POST", body: formData }
      );

      const result = await response.json();

      if (result.status === true || result.success === "1") {
        // alert("Item added to your cart!");
        toast.success("Item added to bag!");
      } else {
        alert(result.message || "Cannot add item.");
      }
    } catch (err) {
      console.error("Add cart error:", err);
    }
  };


  const addToWishList = async (item) => {
    if (!item) return;

    console.log("Button clicked for wishlist:", item);
    const productId = String(item.id);

    // 🚫 already in wishlist
    if (wishlistIds.includes(productId)) return;

    const userId = localStorage.getItem("user_id");

    // ================= GUEST USER =================
    if (!userId) {
      const guestWishlist = getGuestWishlist();

      if (guestWishlist.some(p => String(p.product_id) === productId)) return;

      guestWishlist.push({
        product_id: productId,
        name: item.name,
        price: item.price,
        image: item.images?.[0],
      });

      saveGuestWishlist(guestWishlist);
      setWishlistIds(prev => [...prev, productId]);
      return;
    }

    // ================= LOGGED-IN USER =================
    try {
      const formData = new FormData();
      formData.append("user_id", userId);
      formData.append("product_id", productId);

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_wish",
        { method: "POST", body: formData }
      );

      const result = await response.json();

      if (result.status === true) {
        setWishlistIds(prev => [...prev, productId]);
      }
    } catch (err) {
      console.error("Wishlist error:", err);
    }
  };



  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const parseSizes = (sizeString) => {
    if (!sizeString) return [];
    const sizeIds = sizeString
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    return sizeIds;
  };

  const parseColors = (colorString) => {
    if (!colorString) return [];
    const colorIds = colorString
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    return colorIds;
  };

  // ──── DERIVED: rating breakdown from reviews ────
  const ratingBreakdown = (() => {
    const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    reviews.forEach((r) => {
      const val = Number(r.rating);
      if (val >= 1 && val <= 5) counts[val]++;
    });
    return counts;
  })();

  const averageRating = (() => {
    if (reviews.length === 0) return Number(product?.rating || 0);
    const sum = reviews.reduce((acc, r) => acc + Number(r.rating), 0);
    return (sum / reviews.length).toFixed(1);
  })();

  // ──── which reviews to actually render ────
  const visibleReviews = showAllReviews ? reviews : reviews.slice(0, 1);

  if (loading) {
  return (
    <div className="container-fluid model-section">
      
      {/* Breadcrumb */}
      <div className="sk sk-line" style={{ width: "200px", height: "12px", marginBottom: "20px" }}></div>

      <div className="row">
        {/* LEFT - Image skeleton */}
        <div className="col-lg-6">
          <div className="sk sk-product-main-img"></div>
          <div className="d-flex gap-2 mt-2">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="sk sk-thumb"></div>
            ))}
          </div>
        </div>

        {/* RIGHT - Details skeleton */}
        <div className="col-lg-6">
          {/* Title & brand */}
          <div className="sk sk-line mb-2" style={{ width: "70%", height: "20px" }}></div>
          <div className="sk sk-line mb-3" style={{ width: "40%", height: "15px" }}></div>

          <hr />

          {/* Price */}
          <div className="d-flex gap-3 mb-3">
            <div className="sk sk-line" style={{ width: "80px", height: "22px" }}></div>
            <div className="sk sk-line" style={{ width: "60px", height: "22px" }}></div>
            <div className="sk sk-line" style={{ width: "80px", height: "22px" }}></div>
          </div>

          {/* Size label */}
          <div className="sk sk-line mb-2" style={{ width: "120px", height: "14px" }}></div>
          {/* Size circles */}
          <div className="d-flex gap-2 mb-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="sk sk-size-circle"></div>
            ))}
          </div>

          {/* Color label */}
          <div className="sk sk-line mb-2" style={{ width: "120px", height: "14px" }}></div>
          {/* Color swatches */}
          <div className="d-flex gap-2 mb-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="sk sk-color-swatch"></div>
            ))}
          </div>

          {/* Buttons */}
          <div className="d-flex gap-3 mb-4">
            <div className="sk sk-btn"></div>
            <div className="sk sk-btn"></div>
          </div>

          {/* Delivery section */}
          <div className="sk sk-line mb-2" style={{ width: "150px", height: "14px" }}></div>
          <div className="sk sk-line mb-2" style={{ width: "100%", height: "40px", borderRadius: "6px" }}></div>

          {/* Description lines */}
          <div className="sk sk-line mb-2 mt-3" style={{ width: "100%", height: "13px" }}></div>
          <div className="sk sk-line mb-2" style={{ width: "90%", height: "13px" }}></div>
          <div className="sk sk-line mb-2" style={{ width: "80%", height: "13px" }}></div>

          {/* Specs table */}
          <div className="sk sk-line mb-2 mt-3" style={{ width: "130px", height: "16px" }}></div>
          {[...Array(4)].map((_, i) => (
            <div key={i} className="d-flex gap-3 mb-2">
              <div className="sk sk-line" style={{ width: "100px", height: "13px" }}></div>
              <div className="sk sk-line" style={{ width: "160px", height: "13px" }}></div>
            </div>
          ))}
        </div>
      </div>

      {/* Similar Products skeleton */}
      <div className="mt-5">
        <div className="sk sk-line mb-4" style={{ width: "180px", height: "20px" }}></div>
        <div className="row">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="col-lg-3 col-md-4 col-sm-6 mb-4">
              <div className="sk sk-product-img"></div>
              <div className="sk sk-line mt-2" style={{ width: "50%" }}></div>
              <div className="sk sk-line mt-1" style={{ width: "80%" }}></div>
              <div className="sk sk-line mt-1" style={{ width: "60%" }}></div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}

  if (!product) {
    return (
      <div className="text-center py-5">
        <h3>Product not found.</h3>
      </div>
    );
  }

  const sizeGroups = parseSizes(product.available_size);
  const colorGroups = parseColors(product.available_color);

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const currentProductId = String(product.product_id);
  const isWishlisted = wishlistIds.includes(currentProductId);

  console.log("🔍 CHECK:", {
    currentProductId,
    wishlistIds,
    isWishlisted,
  });



  return (
    <div>
      <div className="container-fluid model-section">
        <div className="model-midsize">
          Home / <span>Casual Shirts For Men</span>
        </div>

        <div className="row" style={{ position: "relative" }}>

          <div
            className="col-lg-6"
            style={
              window.innerWidth > 991
                ? {
                  position: "sticky",
                  top: "80px",
                  alignSelf: "flex-start",
                  height: "fit-content"
                }
                : {}
            }
            onWheel={(e) => {
              if (window.innerWidth > 991) {
                e.preventDefault();
                const rightSide = document.getElementById('right-side-scrollable');
                if (rightSide) {
                  rightSide.scrollTop += e.deltaY;
                }
              }
            }}
          >
            {/* ProductZoom now renders the main image (with magnify + lightbox zoom) and thumbnails together */}
            <ProductZoom
              images={product.multi_image}
              overlay={
                <>
                  {/* ❤️ Wishlist */}
                  <div
                    className="wishlist-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      addToWishList({
                        id: product.product_id,
                        name: product.product_name,
                        price: product.current_price,
                        images: product.multi_image,
                      });
                    }}
                  >
                    <i
                      className={
                        wishlistIds.includes(String(product.product_id))
                          ? "fa-solid fa-heart text-danger"
                          : "fa-regular fa-heart"
                      }
                    ></i>
                  </div>

                  {/* ⭐ Rating */}
                  <div className="rating-box">
                    {Number(product.rating || 0).toFixed(1)} ⭐
                  </div>
                </>
              }
            />
          </div>

          {/* RIGHT SIDE DETAILS */}
          <div
            id="right-side-scrollable"
            className="col-lg-6"
            style={
              window.innerWidth > 768
                ? { overflowY: "auto", maxHeight: "calc(100vh - 100px)" }
                : {}
            }
          >
            <div className="rightcontent">
              <div className="row align-items-start">
                <div className="col-md-10 p-0 d-flex align-items-center gap-2">
                  <div>
                    <h5 className="pdp-title">{product.product_name}</h5>
                  <h5 className="pdp-name">{product.company_name}</h5>
                  </div>

                  <div className="ms-auto">
                    <img src="/img/shield.png" alt="verified" style={{width:"40px"}} />
                    <p>Verified</p>
                  </div>
                </div>

                {/* <div className="col-md-2 text-end">
                  <button
                    className="wishbtn"
                    onClick={() =>
                      addToWishList({
                        id: currentProductId,
                        name: product.product_name,
                        price: product.current_price,
                        images: product.multi_image,
                      })
                    }
                  >
                    <i
                      className={
                        isWishlisted
                          ? "fa-solid fa-heart text-danger"
                          : "fa-regular fa-heart"
                      }
                      style={{ fontSize: "22px" }}
                    ></i>
                  </button>

                </div> */}
              </div>

              {/* <div className="ratebox">
                <p className="num">{product.rating}</p>
                <img src="/img/rating.png" alt="star" />
              </div> */}

              <div className="hr" />

              <div className="disline">
                <span className="cost">{product.current_price}</span>
                <s className="totalcost">{product.old_price}</s>
                <span className="discount">{product.discount}% OFF</span>
              </div>

              <div className="smalltext">Inclusive of all taxes</div>

              {/* SIZE SECTION - Only show for Fashion category */}
              {categoryName.toLowerCase() === "fashion" && (
                <>
                  <div className="size-chart">
                    <h4 className="size">SELECT SIZE</h4>
                    <h4 className="chart">SIZE CHART</h4>
                    <span className="size-button-arrow" />
                  </div>

                  <div className="sizes">
                    {sizeGroups.length === 0 && (
                      <div className="circles">One Size</div>
                    )}

                    {sizeGroups.map((sizeId, index) => {
                      const label = sizeMap[sizeId] || sizeId;

                      return (
                        <div
                          className="circles"
                          key={index}
                          onClick={() => {
                            console.log("Selected Size ID:", sizeId, "Label:", label);
                            setSelectedSize(sizeId);
                          }}
                          style={{
                            border:
                              selectedSize === sizeId
                                ? "2px solid #ff3e6c"
                                : "1px solid #ddd",
                            cursor: "pointer",
                          }}
                        >
                          {label}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}

              {/* COLOR SECTION - Show for Fashion and Electronics */}
              {(categoryName.toLowerCase() === "fashion" ||
                categoryName.toLowerCase() === "electronics") && (
                  <>
                    <div className="size-chart" style={{ marginTop: 16 }}>
                      <h4 className="size">SELECT COLOR</h4>
                    </div>

                    <div className="sizes" style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "45px" }}>
                      {colorGroups.length === 0 && (
                        <div className="circles">Default Color</div>
                      )}

                      {colorGroups.map((colorId, index) => {
                        const colorData = colorMap[colorId];
                        const colorName = colorData?.name || colorId;
                        const colorPreview = colorData?.preview || "#cccccc";


                        return (
                          <div
                            key={index}
                            onClick={() => {
                              console.log("Selected Color ID:", colorId, "Name:", colorName);
                              setSelectedColor(colorId);
                            }}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              cursor: "pointer",
                              padding: "8px",
                              border:
                                selectedColor === colorId
                                  ? "2px solid #ff3e6c"
                                  : "1px solid #ddd",
                              borderRadius: "8px",
                              minWidth: "70px",
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                backgroundColor: colorPreview,
                                border: "2px solid #ddd",
                                marginBottom: "4px",
                              }}
                            />
                            <span style={{ fontSize: "12px", textAlign: "center" }}>
                              {colorName}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}

              {/* BUTTONS */}
              {/* <div className="newdiv" style={{ marginTop: 12 }}>
                <Link to="/bag">
                  <button className="cartbtn" onClick={addToCart}>
                    <img src="/img/thunder.png" alt="bag" style={{ width: "25px" }} />
                    Buy Now
                  </button>
                </Link>

                <button className="cartbtn" onClick={addToCart}>
                  <img src="/img/bag.svg" alt="bag" />
                  Add to cart
                </button>
              </div> */}

              <div className="newdiv" style={{ marginTop: 12 }}>
                <Link to="/bag">
                  <button className="Addto-cart me-2 p-2" onClick={addToCart}>
                    <img src="/img/thunder.png" alt="bag" />
                    Buy Now
                  </button>
                </Link>

                <button className="Addto-cart ms-2 p-2" onClick={addToCart}>
                  <img src="/img/bag.svg" alt="bag" />
                  Add to cart
                </button>
              </div>

              {/* Rest of your design untouched */}
              {/* DELIVERY, DETAILS, REVIEWS, SUPPLIER INFO, etc. */}
              {/* ------------------------- */}

              <div className="delivary-section" style={{ marginTop: 12 }}>
                <span>DELIVERY OPTIONS</span>
                <img className="van" src="/img/van.jpg" alt="van" />
              </div>

              <div className="checkbox" style={{ marginTop: 8 }}>
                <input type="number" placeholder="Enter a pin code" />
                <h4 className="pin">
                  Please enter PIN code to check delivery time & Pay on Delivery
                  Availability
                </h4>
                <div className="delivery-info">
                  <h6><span><i class="fa-regular fa-truck"></i></span>Get it by Fri, Apr 24</h6>
                  <h6><span><img src="/img/cash-on-delivery.png" alt="Pay on Delivery" /></span>Pay on delivery available</h6>
                  <h6><span><img src="/img/product-return.png" alt="Pay on Delivery" /></span>Easy 14 days return & exchange available</h6>
                </div>
              </div>

              <div className="bigtextcontainer">
                <div>
                  <h4 className="bigtext">{product.description}</h4>
                </div>
              </div>

              <div className="newdiv" style={{ marginTop: 12 }}>
                <h4 className="font">
                  BEST OFFERS
                  <img className="tag" src="/img/offer-key.png" alt="offer" />
                </h4>
              </div>

              <div>
                <h4 className="font">
                  Best Price:
                  <span className="orange">{product.current_price}</span>
                </h4>
              </div>

              <div className="smalltexter">View Eligible Products</div>

              <div className="hr" />

              <div className="product-newdiv">
                <h4 className="font">PRODUCT DETAILS</h4>
                <h4 className="bigtext">{product.product_details}</h4>
              </div>

              <div className="products-newdiv">
                <h4 className="font">Material &amp; Care</h4>
              </div>
              <div>
                <h4 className="bigtext-noGap">{product.material || "N/A"}</h4>
              </div>
              <div>
                <h4 className="bigtext-noGap">Machine-wash</h4>
              </div>

              <div className="products-newdiv">
                <h4 className="font">Specifications</h4>
              </div>

              {/* DYNAMIC SPECIFICATIONS */}
              <div className="index-tableContainer">
                {getSpecifications().map((spec, index) => (
                  <div className="index-row" key={index}>
                    <div className="index-rowKey">{spec.key}</div>
                    <div className="index-rowValue">{spec.value}</div>
                  </div>
                ))}
              </div>

              <div>
                <h4 className="font">Why this product?</h4>
                <p></p>
              </div>

              {/* <hr /> */}

              {/* ══════════════════════════════════════════════
                  RATINGS  –  now driven by live review data
                  ══════════════════════════════════════════════ */}
              {/* <div className="rating-div">
                <h4>
                  RATINGS{" "}
                  <i className="fa-regular fa-star" style={{ width: "5%" }}></i>
                </h4>
                <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-12 rating-div1">
                    <h1>
                      {averageRating} <i className="fa-solid fa-star"></i>
                    </h1>
                    <p style={{ fontSize: 13, color: "#666" }}>
                      {reviews.length} {reviews.length === 1 ? "Review" : "Reviews"}
                    </p>
                  </div>

                  <div className="col-lg-1 col-md-1 col-sm-12 rating-div-vl"></div>

                  <div className="col-lg-6 col-md-6 col-sm-12 rating-div2">
                    {[5, 4, 3, 2, 1].map((star) => {
                      const count = ratingBreakdown[star];
                      const pct = reviews.length > 0 ? (count / reviews.length) * 100 : 0;
                      return (
                        <div
                          key={star}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            marginBottom: 5,
                          }}
                        >
                  
                          <span style={{ fontSize: 13, minWidth: 20, textAlign: "right" }}>
                            {star}
                          </span>
                          <i className="fa-solid fa-star" style={{ fontSize: 12, color: "#f5a623" }} />

                        
                          <div
                            style={{
                              flex: 1,
                              height: 8,
                              background: "#eee",
                              borderRadius: 4,
                              overflow: "hidden",
                            }}
                          >
                            <div
                              className="progress-fill"
                              style={{
                                width: `${pct}%`,
                                height: "100%",
                                background: "#f5a623",
                                borderRadius: 4,
                                transition: "width 0.4s ease",
                              }}
                            />
                          </div>

                
                          <span style={{ fontSize: 13, minWidth: 22 }}>{count}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div> */}

              <hr />

              {/* ══════════════════════════════════════════════
                  CUSTOMER PHOTOS  –  pulled from review images
                  ══════════════════════════════════════════════ */}
              {(() => {
                // collect all review images into a flat list (max 5 shown)
                const allReviewImages = reviews.flatMap((r) =>
                  Array.isArray(r.image)
                    ? r.image.map((img) => ensurePublicPath(img))
                    : r.image
                      ? [ensurePublicPath(r.image)]
                      : []
                );
                return allReviewImages.length > 0 ? (
                  <div className="row customer-review">
                    <h5>Customer Photos</h5>
                    <div className="customer-review-img">
                      {allReviewImages.slice(0, 5).map((img, idx) => (
                        <img key={idx} src={img} alt={`customer-photo-${idx}`} />
                      ))}
                    </div>
                  </div>
                ) : null;
              })()}

              {/* ══════════════════════════════════════════════
                  CUSTOMER REVIEWS  –  1 shown, expand on click
                  ══════════════════════════════════════════════ */}
              <div className="row customer-reviews" style={{ marginTop: 8 }}>
                <h5>Customer Reviews</h5>

                {/* no reviews at all */}
                {reviews.length === 0 && (
                  <p style={{ fontSize: 14, color: "#999", margin: "8px 0" }}>
                    No reviews yet. Be the first to review this product!
                  </p>
                )}

                {/* visible review cards */}
                {visibleReviews.map((review) => (
                  <ReviewCard
                    key={review.id}
                    review={review}
                    ensurePublicPath={ensurePublicPath}
                  />
                ))}

                {/* ── Show All / Show Less button ── */}
                {reviews.length > 1 && (
                  <button
                    type="button"
                    onClick={() => setShowAllReviews((prev) => !prev)}
                    style={{
                      display: "inline-block",
                      marginTop: 10,
                      padding: "8px 20px",
                      background: "transparent",
                      border: "1.5px solid #ff3e6c",
                      color: "#ff3e6c",
                      borderRadius: 20,
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: "pointer",
                      transition: "background 0.2s, color 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#ff3e6c";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.color = "#ff3e6c";
                    }}
                  >
                    {showAllReviews
                      ? "Show Less"
                      : `Show All Reviews (${reviews.length})`}
                  </button>
                )}
              </div>

              <hr />

              <div className="seller-div">
                <p>
                  Product Code: <strong>{product.product_id}</strong>
                </p>
                <p>
                  Seller: <span>{product.assign_vendor}</span>
                </p>
                {product.show_seller === "yes" && (
                  <div>
                    <a onClick={handleOpen} style={{ cursor: "pointer" }}>
                      View Supplier Information
                    </a>

                    {isOpen && (
                      <SupplierInfoModal
                        onClose={handleClose}
                        sellerId={product.seller_id}
                        productId={product.product_id}
                      />
                    )}
                  </div>
                )}

              </div>

            </div>
          </div>
        </div>

        {/* SIMILAR PRODUCTS */}
        {/* SIMILAR PRODUCTS */}
        <div className="row similar-product-section mt-2">
          <h3>Similar Products</h3>

          <div className="col-lg-12 col-md-12 col-sm-12 products-right">
            <div className="row">
              {similarProducts.map((item) => (
                <div
                  key={item.id}
                  className="col-6 col-lg-3 col-md-4 col-sm-6 product-list"
                  onMouseEnter={() => setHoveredItemId(item.id)}
                  onMouseLeave={() => setHoveredItemId(null)}
                  style={{ position: "relative" }}
                >
                  <Link className="product" to={`/model/${item.id}`}>
                    <div className="image-container">
                      {hoveredItemId === item.id && item.images.length > 1 ? (
                        <Slider {...sliderSettings}>
                          {item.images.map((img, idx) => (
                            <img key={idx} src={img} alt={`slide-${idx}`} />
                          ))}
                        </Slider>
                      ) : (
                        <div className="product-img">
                          <img src={item.images[0]} alt={item.name} />
                          <div className="product-rating">
                            <p>
                              {item.rating} <i className="fa-solid fa-star"></i> |{" "}
                              {item.viewers}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {hoveredItemId === item.id && (
                      <div className="wishlist">
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            // prevent duplicate add
                            if (!wishlistIds.includes(item.id)) {
                              addToWishList(item);
                            }
                          }}
                        >
                          <i
                            className={
                              wishlistIds.includes(String(item.id))
                                ? "fa-solid fa-heart text-danger"
                                : "fa-regular fa-heart"
                            }
                          ></i>
                          Wishlist
                        </button>
                      </div>
                    )}



                    <div className="product-detail">
                      <div className="stock-availability">{item.stock}</div>
                      <div className="brand">{item.brand}</div>
                      <div className="name">{item.name}</div>
                      <div className="price">
                        ₹{item.price}
                        <span className="line-through"> ₹{item.oldPrice}</span>
                        <span className="discount"> ({item.discount}% OFF)</span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>


      </div>

      <Footer />
    </div>
  );
};

export default Model;